import { isFieldOptionalForIws } from "./brokerageFields";

const addId = (set, id) => {
  if (id !== null && id !== undefined && id !== "") set.add(String(id));
};

export const isConfirmedMinorMember = (household, memberId) => {
  const id = String(memberId);
  const member = (household?.members || []).find((m) => String(m?.id) === id);
  return member?.is_minor === true;
};

export const getOwnerEquivalentMemberIds = (household) => {
  const ids = new Set();
  (household?.accounts || []).forEach((account) => {
    (account?.owners_info || []).forEach((owner) => addId(ids, owner?.id));
    const trustInfo = account?.trust_info;
    if (trustInfo && typeof trustInfo === "object") {
      addId(ids, trustInfo.grantor_or_settler);
      (trustInfo.trustees || []).forEach((trustee) =>
        addId(ids, typeof trustee === "object" ? trustee?.id : trustee),
      );
    }
  });
  return ids;
};

export const getTrustedContactMemberIds = (household) => {
  const ids = new Set();
  (household?.accounts || []).forEach((account) => {
    (account?.trusted_contacts || []).forEach((contact) =>
      addId(ids, contact?.household_member_id),
    );
  });
  return ids;
};

export const getBeneficiaryMemberIds = (household) => {
  const ids = new Set();
  (household?.accounts || []).forEach((account) => {
    (account?.beneficiaries || []).forEach((beneficiary) =>
      addId(ids, beneficiary?.household_member_id),
    );
  });
  return ids;
};

export const isIwsOptionalPiiMember = (household, memberId, brokerageFlags) => {
  if (!isFieldOptionalForIws(brokerageFlags) || !memberId) return false;
  const id = String(memberId);
  if (!getBeneficiaryMemberIds(household).has(id)) return false;
  if (getOwnerEquivalentMemberIds(household).has(id)) return false;
  if (getTrustedContactMemberIds(household).has(id)) return false;
  return true;
};

export const IWS_WAIVED_MEMBER_FIELDS = ["title"];

export const IWS_WAIVED_MEMBER_PII_FIELDS = [
  "ssn_or_tin",
  "dob",
  "country_of_citizenship",
  "email",
];

export const MINOR_WAIVED_FIELDS = ["email"];

export const getWaivedMemberFields = (household, memberId, brokerageFlags) => {
  const waived = new Set();
  if (isConfirmedMinorMember(household, memberId)) {
    MINOR_WAIVED_FIELDS.forEach((field) => waived.add(field));
  }
  if (!isFieldOptionalForIws(brokerageFlags)) return waived;
  IWS_WAIVED_MEMBER_FIELDS.forEach((field) => waived.add(field));
  if (isIwsOptionalPiiMember(household, memberId, brokerageFlags)) {
    IWS_WAIVED_MEMBER_PII_FIELDS.forEach((field) => waived.add(field));
  }
  return waived;
};
